const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;
const DropshippingPlatforms = () => {
  const { api, t } = usePrintful();
  const resource = useResource(async () => ({ ...(await api.getPlatform()), ...(await api.getConnection()) }), [api]);
  const platform = resource.data?.platform;
  const connection = resource.data?.connection;
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_pf_platform_title", "Printful platform"), description: t("h_pf_platform_desc", "Print-on-demand products fulfilled from your own Printful account.") }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, reload: resource.reload, t }, platform ?
      h("article", { className: "pfds-card" }, h("div", { className: "pfds-card-body" },
        h("div", { className: "pfds-row pfds-between" }, h("h3", null, platform.name), h(StatusBadge, { status: connection?.status || "not_connected", t })),
        h("p", { className: "pfds-muted" }, t("h_pf_platform_explain", "Elakay synchronizes your designed store products. Printful manufactures and ships after a paid order is submitted.")),
        h("div", { className: "pfds-row" }, h(LinkButton, { to: "/dropshipping/printful/connect" }, connection?.status === "active" ? t("h_pf_manage", "Manage connection") : t("h_pf_connect", "Connect Printful")), h(LinkButton, { to: "/dropshipping/printful/products", variant: "secondary" }, t("h_pf_products", "Products")))
      )) : null)
  );
};
module.exports = { DropshippingPlatforms };
